export default __webpack_public_path__ + "static/media/10-shine.5ebea184.png";